import { useEffect, useState } from "react";

export const useDetectKeyboardOpen = (minKeyboardHeight = 300) => {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState<boolean>(false);
  const [visualViewportHeight, setVisualViewportHeight] = useState<number>(window.innerHeight);

  useEffect(() => {
    const listener = () => {
      if (!visualViewport) return;
      const newState = window.screen.height - minKeyboardHeight > visualViewport.height;

      if (isKeyboardOpen !== newState) {
        setVisualViewportHeight(visualViewport.height);
        setIsKeyboardOpen(newState);
      }
    };
    if (visualViewport) {
      visualViewport.addEventListener("resize", listener);
    }
    return () => {
      if (visualViewport) {
        visualViewport.removeEventListener("resize", listener);
      }
    };
  });

  return { isKeyboardOpen, visualViewportHeight };
};
